(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = (scope = document) => {
    scope.querySelectorAll('[data-ambient-video]').forEach(video => {
      if (video.dataset.brandBound) return;
      video.dataset.brandBound = 'true';
      const control = video.closest('figure')?.querySelector('[data-video-toggle]');
      const sync = () => {
        if (!control) return;
        control.textContent = video.paused ? 'Abspielen' : 'Pause';
        control.setAttribute('aria-label', `${video.getAttribute('aria-label')}: ${video.paused ? 'abspielen' : 'pausieren'}`);
      };
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      control?.addEventListener('click', () => {
        if (video.paused) {
          delete video.dataset.userPaused;
          video.play().catch(sync);
        } else {
          video.dataset.userPaused = 'true';
          video.pause();
        }
      });
      if (reducedMotion.matches) {
        video.removeAttribute('autoplay');
        video.pause();
      }
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) video.pause();
            else if (!reducedMotion.matches && !video.dataset.userPaused) video.play().catch(sync);
          });
        }, { threshold: 0.15 });
        observer.observe(video);
      }
      sync();
    });

    scope.querySelectorAll('[data-product-gallery]').forEach(gallery => {
      if (gallery.dataset.brandBound) return;
      gallery.dataset.brandBound = 'true';
      const slides = gallery.querySelectorAll('[data-gallery-slide]');
      const buttons = gallery.querySelectorAll('[data-gallery-select]');
      buttons.forEach(button => button.addEventListener('click', () => {
        const selected = Number(button.dataset.gallerySelect);
        slides.forEach((slide, index) => {
          slide.hidden = index !== selected;
          if (slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause());
        });
        buttons.forEach((thumb, index) => thumb.setAttribute('aria-pressed', String(index === selected)));
      }));
    });

    scope.querySelectorAll('[data-branch-search]').forEach(search => {
      if (search.dataset.brandBound) return;
      search.dataset.brandBound = 'true';
      const root = search.closest('section');
      const cards = root.querySelectorAll('[data-branch-card]');
      const counter = root.querySelector('[data-branch-count]');
      const normalize = value => value.toLocaleLowerCase('de').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      search.addEventListener('input', () => {
        const terms = normalize(search.value).trim().split(/\s+/);
        let count = 0;
        cards.forEach(card => {
          card.hidden = !terms.every(term => normalize(card.dataset.search).includes(term));
          if (!card.hidden) count++;
        });
        counter.textContent = count ? `${count} ${count === 1 ? 'Filiale gefunden' : 'Filialen gefunden'}` : 'Keine passende Filiale gefunden. Versuche einen Stadtteil oder eine Straße.';
      });
    });

    scope.querySelectorAll('[data-menu-photo]').forEach(link => {
      if (link.dataset.brandBound) return;
      link.dataset.brandBound = 'true';
      const change = () => {
        const image = document.querySelector('[data-menu-image]');
        if (image) {
          image.src = link.dataset.menuPhoto;
          image.alt = link.querySelector('span')?.textContent.trim() || '';
          const note = document.querySelector('[data-menu-disclosure]');
          const src = link.dataset.menuPhoto;
          if (note) {
            const label = src.includes('fruehstueck-20261016') ? image.dataset.breakfastLabel : src.includes('kuenne-catering-') ? '' : src.includes('stollen') ? image.dataset.productLabel : src.includes('hofbaeckerei-neu') ? image.dataset.hofLabel : '';
            note.textContent = label;
            note.hidden = !label;
          }
        }
      };
      link.addEventListener('pointerenter', change);
      link.addEventListener('focus', change);
    });

    scope.querySelectorAll('[data-event-date]').forEach(input => {
      const now = new Date();
      const localDate = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
      input.min = localDate;
    });

    scope.querySelectorAll('[data-open-menu]').forEach(button => {
      if (button.dataset.ariaBound) return;
      button.dataset.ariaBound = 'true';
      button.addEventListener('click', () => button.setAttribute('aria-expanded', 'true'));
      document.getElementById(button.getAttribute('aria-controls'))?.addEventListener('close', () => button.setAttribute('aria-expanded', 'false'));
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

